import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Copy, Plus } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';

const CartSuccessModal = ({ isOpen, onClose, onDesignAnother, onDuplicateDesign }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { /* Prevent closing */ }}>
      <DialogContent 
        className="sm:max-w-md modal-cart-success" 
        hideClose
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-2xl">Produkten är tillagd i varukorgen!</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 pt-4">
          <Button
            onClick={() => navigate('/cart')}
            className="w-full"
            size="lg"
          >
            Till varukorgen →
          </Button>
          
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <Separator />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-background text-muted-foreground">eller</span>
            </div>
          </div>

          <div className="space-y-2">
            <Button
              onClick={() => {
                onClose();
                onDuplicateDesign();
              }}
              variant="secondary"
              className="w-full"
              size="lg"
            >
              <Copy className="mr-2 h-5 w-5" />
              Använd samma design på en annan modell
            </Button>
            
            <Button
              onClick={() => {
                onClose();
                onDesignAnother();
              }}
              variant="secondary"
              className="w-full"
              size="lg"
            >
              <Plus className="mr-2 h-5 w-5" />
              Börja om med en ny design
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CartSuccessModal; 